import { sortBy } from "lodash";

class TreeNode<T> {
  private order: number;
  children: TreeNode<any>[] | null = null;
  data?: T;

  constructor(data?: T, order = 0) {
    this.data = data;
    this.order = order;
  }

  addChildNode(node: TreeNode<any>) {
    if (!this.children) {
      this.children = [];
    }
    this.children.push(node);
    sortBy(this.children, ["order"]);
  }

  removeChildNode(node: TreeNode<any>) {
    if (this.children && this.children.length > 0) {
      const index = this.children.indexOf(node);
      if (index > -1) {
        this.children.splice(index, 1);
      }
    }
  }

  isLeaf() {
    return !this.children || this.children.length === 0;
  }
}

class Tree {
  readonly root: TreeNode<never>;

  constructor() {
    this.root = new TreeNode();
  }

  visitDepthFirst(
    callback: (node: TreeNode<any>, context: any) => boolean,
    context: object
  ) {
    const remainingNodes: TreeNode<any>[] = [this.root];
    let keepVisiting = true;
    while (keepVisiting && remainingNodes.length > 0) {
      const nextNode = remainingNodes.pop();
      if (nextNode) {
        const children = nextNode.children;
        if (children) {
          remainingNodes.push(...children);
        }
        keepVisiting = callback(nextNode, context);
      }
    }
  }
}

export { TreeNode, Tree };
